import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";

const Learning = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 특허 받은 학습법`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);
  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/philosophy">아소비 이념</a>
              </li>
              <li>
                <a href="/learning" className="sel">
                  특허받은 학습법
                </a>
              </li>
              <li>
                <a href="/program">아소비 프로그램</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="learning">
          <div className="sect learning01">
            <div className="wrap">
              <div className="tit init">특허로 인정받은 아소비 한글</div>
              <div className="txt init">
                아소비 한글은 피아제 이론을 바탕으로 <br className="mo-view" />
                아동의 발달 단계에 맞는 학습법을 적용하여{" "}
                <br className="pc-view" />
                독창적이고 효과적인 <br className="mo-view" />
                프로그램으로 특허를 취득하여 우수성을 인정받았습니다.
              </div>
            </div>
            <div className="bot init">
              <div className="wrap">
                <strong>*피아제 이론(인지발달이론)이란?</strong>
                <p>
                  아동기가 인지 발달의 핵심적이고 중요한 시기이며 아이들이
                  성장하는 과정에서 만나는 교육적 환경과 학습 경험이 인지 능력의
                  발달에 중요한 영향을 준다는 이론입니다.
                  <br /> 또한 인지 발달 수준에 따라 아이의 학습 능력이 다르므로
                  발달에 맞는 학습이 최고의 학습임을 강조한 이론입니다.
                </p>
              </div>
            </div>
          </div>
          <div className="sect learning02">
            <div className="img pc-view">
              <img src="../custom-resources/img/img_learning_learn02_img.jpg" alt="" />
            </div>
            <div className="img mo-view">
              <img
                src="../custom-resources/img/img_learning_learn02_img_mo.png"
                alt=""
              />
            </div>
            <div className="eff">
              <span className="star1"></span>
              <span className="star2"></span>
              <span className="star3"></span>
            </div>
          </div>
          <div className="sect learning03">
            <div className="wrap">
              <div className="tit init">
                <strong>특허</strong>받은 <strong>아소비 한글</strong>은
                다릅니다!
              </div>
            </div>
          </div>
          <div className="sect learning04">
            <div className="wrap">
              <div className="tit init">
                아소비 한글은 언어 발달의 민감기(sensitive period)에{" "}
                <br className="mo-view" />
                있는 <br className="pc-view" /> 아이들의 발달적 특성을 고려하여{" "}
                <br className="mo-view" /> 한 글자에 <br className="pc-view" />
                우뇌적이며 직관적인 경험을 <br className="mo-view" />
                연결하여 학습하게 합니다.
              </div>
              <div className="img">
                <img
                  src="../custom-resources/img/img_learning_learn04_after.png"
                  className="pc-view"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_learning_learn04_after_mo.png"
                  className="mo-view"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="sect learning05">
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_learning_learn05_img.gif"
                  className="pc-view"
                  alt=""
                />
                <img
                  src="../custom-resources/img/img_learning_learn05_img_mo.gif"
                  className="mo-view"
                  alt=""
                />
              </div>
              <div className="con">
                <div className="tit">
                  발달적 특성에 맞는 과학적이고 체계적인 아소비 한글
                </div>
                {/* <div className="txt">아소비 한글은 가, 나, 다 또는 <br className="mo-view">모자, 나비, 가방 등으로 배우지 않습니다.</div>  */}
              </div>
              <div className="con">
                <div className="tit">
                  이미지와 함께 쉽고 빠르게 익히는 아소비 한글
                </div>
                {/* <div className="txt">아소비 한글은 하루 동안 배우는 글자의 자음과 모음이 확실히 다릅니다.</div>  */}
              </div>
              <div className="con">
                <div className="tit">
                  창의교구와 함께 감각적으로 경험하여 <br />
                  재미있게 습득하는 아소비 한글
                </div>
                {/* <div className="txt">아소비 한글은 반복적으로 암기하는 주입식 학습이 아닙니다.</div>  */}
              </div>
            </div>
          </div>
          <div className="sect learning06">
            <div className="wrap">
              <div className="tit init">
                작은 음절을 시작으로 <br className="mo-view" />
                확장해 가는 아소비 한글
              </div>
              <div className="txt init">
                비고츠키의 이론을 토대로 한글의 과학적 구성 원리에 맞게 <br />{" "}
                소리가 있는 작은 음절에서 시작하여 점차 확장하는 학습으로 <br />{" "}
                <strong>계단을 오르듯 한 단계씩</strong> 배울 수 있는 특허받은
                프로그램입니다.
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Learning;
